export const TRIGGERS_PART01 = [
  {
    id: 'demo-trg-demo-request',
    title: 'Inbound demo request',
    enabled: true,
    description:
      'Turns an inbound demo request into a HubSpot deal and a ready-to-send reply within a minute of it arriving.',
    when: { app: 'Gmail', event: 'New email received', filter: 'Subject or body mentions “demo”, “pricing”, or “trial”' },
    steps: [
      'Pull the sender’s name, company, and role from the email and signature',
      'Create or update the contact in HubSpot and open a deal in Discovery',
      'Post a summary with the deal link to #sales',
      'Draft a reply offering three slots from your calendar, for you to review',
    ],
    apps: ['Gmail', 'HubSpot', 'Slack'],
  },
  {
    id: 'demo-trg-closed-won',
    title: 'Deal closed won',
    enabled: true,
    description: 'Celebrates the win and gets onboarding moving the moment a deal closes.',
    when: { app: 'HubSpot', event: 'Deal stage changed', filter: 'New stage is Closed Won' },
    steps: [
      'Post the win to #wins with amount, owner, and the competitor we beat',
      'Create the onboarding checklist page in Notion',
      'Draft a kickoff email to the customer’s champion',
    ],
    apps: ['HubSpot', 'Slack', 'Notion', 'Gmail'],
  },
  {
    id: 'demo-trg-github-bug',
    title: 'New bug report triage',
    enabled: true,
    description: 'Gives every new bug a first-pass triage before an engineer opens it.',
    when: { app: 'GitHub', event: 'Issue labeled', filter: 'Label is bug in data-obs/data-obs-chat' },
    steps: [
      'Read the issue and any linked logs or screenshots',
      'Find similar open or recently closed issues',
      'Suggest a severity and an owner from the files involved',
      'Post the triage summary to #eng-triage',
    ],
    apps: ['GitHub', 'Slack'],
  },
]
